import { DayComparator } from "./day-comparator";
import { HourComparator } from "./hour-comparator";
import { MonthComparator } from "./month-comparator";
import { SemesterComparator } from "./semester-comparator";
import { YearComparator } from "./year-comparator";
import { TimeResolution } from "./time-resolution";
import { TimeComparator } from "./time-comparator";

export abstract class TimeComparatorFactory {

    static create(comparatorType: string) : TimeComparator {

        switch (comparatorType) {
            case TimeResolution.ONE_HOUR:
                return new HourComparator();
            case TimeResolution.ONE_DAY:
                return new DayComparator();
            case TimeResolution.ONE_MONTH:
                return new MonthComparator();
            default:
                return new DayComparator();
        }
    }
}